import { useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useAssessmentContext } from '../../../../providers/AssessmentContext';

function TextlistChoice({ choice, handleClick, isDisabled, selected }) {
    const isSelected = selected.includes(choice.value);
    return (
        <div
            key={choice.value}
            className={`flex justify-start p-4 items-start transition-opacity duration-200 cursor-pointer overflow-hidden ${isDisabled ? 'opacity-50 cursor-default' : ''}`}
            data-attr={choice.value}
            onClick={function () {
                handleClick(choice.value);
            }}>
            <span
                className={`${isSelected ? 'bg-gem-green' : ''} block relative w-5 h-5 border-4 border-gem-green mr-4 mt-1 pointer-events-none`}>
                <FaCheck
                    className={`${isSelected ? 'block' : 'hidden'} transition absolute-center w-2 scale-150 pointer-events-none text-white`}
                />
            </span>
            <span className="mt-1 block font-semibold flex-1 relative leading-normal text-xs xs:text-sm sm:text-base pointer-events-none">
                {choice.label}
            </span>
        </div>
    );
}

function CheckList({ choices, choiceHandler, uniqueChoice = null }) {
    const [selected, setSelected] = useState([]);

    function isDisabled(val) {
        if (!uniqueChoice) return false;
        if (selected.includes(uniqueChoice) && val !== uniqueChoice) return true;
        if (selected.length > 0 && !selected.includes(uniqueChoice) && val === uniqueChoice)
            return true;
        return false;
    }

    function handleClick(val) {
        if (isDisabled(val)) return;
        setSelected(function (prev) {
            return prev.includes(val)
                ? prev.filter(function (v) {
                      return v !== val;
                  })
                : [...prev, val];
        });
    }

    function handleContinue() {
        choiceHandler(selected);
    }

    if (!choices || choices.length === 0) return null;

    //Split the unique choice from the other choices
    const [uniqueChoiceOption, nonUniqueChoiceOptions] = choices?.reduce(
        ([unique, nonUnique], choice) => {
            if (choice.value === uniqueChoice) {
                return [choice, nonUnique];
            } else {
                return [unique, [...nonUnique, choice]];
            }
        },
        [null, []],
    );

    return (
        <>
            <p className="lg:text-[21px] text-gray-light mb-2">Check all that apply</p>

            {uniqueChoiceOption ? (
                <div
                    key="unique-choice"
                    className="bg-gray-dark divide-y divide-purple-medium border border-purple-medium mb-4">
                    <TextlistChoice
                        key={`unique-choice`}
                        choice={uniqueChoiceOption}
                        handleClick={handleClick}
                        isDisabled={isDisabled(uniqueChoiceOption.value)}
                        selected={selected}
                    />
                </div>
            ) : null}
            {nonUniqueChoiceOptions.map(function (c, i) {
                return (
                    <div
                        key={`non-unique-choice-${i}`}
                        className="divide-y divide-purple-medium border border-purple-medium">
                        <TextlistChoice
                            key={`choice-${i}`}
                            choice={c}
                            handleClick={handleClick}
                            isDisabled={isDisabled(c.value)}
                            selected={selected}
                        />
                    </div>
                );
            })}

            <button
                className="btn-primary mt-5 block text-center w-full mx-auto disabled:opacity-25 disabled:pointer-events-none"
                disabled={selected.length === 0}
                onClick={handleContinue}>
                Continue
            </button>
        </>
    );
}

function ChecklistQuestion({ inputSubmitHandler }) {
    const { currentQuestionData, questionChoices } = useAssessmentContext();

    return (
        <CheckList
            choices={questionChoices}
            choiceHandler={inputSubmitHandler}
            uniqueChoice={currentQuestionData?.uniqueChoice}
        />
    );
}

export default ChecklistQuestion;
